import React, { ChangeEvent, useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  PageTitleAndSubTitle,
  OverviewCard as OverViewCard,
  // NetworkUtilizationChart,
  CardTable,
  Breadcrumbs,
  Columns,
  CardComponent,
  BasicTable,
  DashedStandardDropdown,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import networkLeakage from '../../core-utils/messages/networkLeakage';
import properties from '../../core-utils/properties';
import {
  memberTableColumns,
  networkUtilizationColumns,
} from './networkLeakageConstants';
import axios from 'axios';
import Loader from '../../_components/molecules/Loader';
import {
  AmountRatioAPIResponse,
  defaultOutNetworkMembersColumns,
  NetworkSummaryAPIResponse,
  NetworkUtilizationApiResponse,
  outNetworkColumns,
} from '../../core-utils/helper-utils/networkLeakageHelpers';
import {
  addPrefix,
  numberToCurrencyFormatter,
  numFormatterWithSuffix,
} from '../../core-utils/helper-utils/helper';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { useStores } from '../../stores';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import moment from 'moment';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import { PATIENT_DETAILS } from '../../core-utils/routes';
import { useNavigate, useLocation } from 'react-router-dom';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import {
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../core-utils/helper-utils/tableSortHelper';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import FeatureAccessModal from '../../_components/organisms/FeatureAccessModal';
// import QueryIcon from '../../_components/atoms/Icons/QueryIcon';
import { observer } from 'mobx-react';
import CustomColumnsTable from '../../_components/organisms/CustomColumnsTable';
import {
  downloadPdf,
  handleDownloadCSV,
} from '../../core-utils/helper-utils/downloadPdfHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import {
  formatMembersListData,
  getColumns,
} from '../../core-utils/helper-utils/customColumnsHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { getMonth } from '../../core-utils/helper-utils/wasteCalculatorInternalPageHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import DateFilter from '../../_components/molecules/DateFilter';
import componentConstants from '../../core-utils/messages/componentConstants';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { getCohortMembersCount } from '../../core-utils/axios/Cohort/Summary';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';

const useStyles = makeStyles()({
  mainDiv: {
    padding: '40px 0px 36px 63px',
    width: '1182px',
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '24px',
    marginBottom: '28px',
  },
  OverViewCardMargin: {
    marginRight: '24px',
  },
  queryIconGrid: {
    padding: '10px 0px 10px 22px',
  },
  queryDataOverallGrid: {
    margin: '10px 10px 10px 0px',
    height: '44px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #DADEEF',
    width: '1176px',
    borderRadius: '4px',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  queryDataTypography: {
    padding: '10px 10px',
    height: '44px',
    borderRight: '1px solid #DADEEF',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  queryDataGrid: {
    maxWidth: '400px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: '60px',
  },
  editQueryGrid: {
    padding: '10px 40px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #DADEEF',
  },
  tooltip: {
    backgroundColor: patientAccessTheme.palette.grey[900],
    padding: '10px',
    fontSize: '13px',
    fontFamily: 'Inter',
    fontWeight: 400,
    lineHeight: '16px',
    color: patientAccessTheme.palette.status.white,
  },
  arrow: {
    color: patientAccessTheme.palette.grey[900],
    marginLeft: '50px',
  },
  popper: {
    marginTop: '-20px',
    marginLeft: '-20px',
  },
  donuts: {
    display: 'flex',
    gap: '24px',
    marginBottom: '28px',
  },
});

const NetworkLeakagePage: React.FC = observer(({}) => {
  //constants
  const navigate = useNavigate();
  const location = useLocation();
  const loginPageStore = useStores().loginPageStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const memberSummaryStore = useStores().memberSummaryStore;
  const employerGroupStore = useStores().employerGroupStore;
  const state: any = location.state;
  const networkIndicator = state?.networkIndicator;
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;

  //states
  const [loading, setLoading] = useState<boolean>(false);
  const [networkSummaryAPIRes, setNetworkSummaryAPIRes] = useState<
    NetworkSummaryAPIResponse[]
  >();
  const [
    networkUtilization,
    setNetworkUtilization,
  ] = useState<NetworkUtilizationApiResponse>();
  const [
    selectedNetworkIndicator,
    setSelectedNetworkIndicator,
  ] = useState<string>(
    networkIndicator ??
      employerGroupStore.employerGroupResponseData.network_indicator_list[0],
  );
  const [openFeatureAccessModal, setOpenFeatureAccessModal] = useState(false);

  //Enrollment Cards--
  //Summary cards states and api call functions
  const [totalCost, setTotalCost] = useState<AmountRatioAPIResponse>({
    member_paid: 0,
    plan_paid: 0,
    member_paid_ratio: 0,
    plan_paid_percentage: 0,
    total_paid: 0,
    network_indicator: '',
  });
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const screenName = allScreenLabel;
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        networkLeakage.titleAndSubtitle.title,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  //   await axios
  //     .post(properties.aiqBaseUrl + properties.summaryBaseUrl, {
  //       startDate:
  //         aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
  //       endDate:
  //         aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
  //       eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
  //       claim_id_list: cohortDetailsStore.claimIdList,
  //       member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
  //       max_claim_date:
  //         employerGroupStore?.employerGroupResponseData?.max_claim_date,
  //     })
  //     .then((res) => {
  //       if (res?.status === 200) {
  //         setTotalEnrolled(formatTotalEnrolled(res?.data?.data));
  //         setTotalCost(formatTotalCost(res?.data?.data));
  //       }
  //     })
  //     .catch((error) => {
  //       return error;
  //     });
  // };

  // Edit duration related states and functions

  const pathStore = useStores().pathStore;
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;
  const { totalResults, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCohortMembersCount(
        employerGroupStore.employerGroupResponseData.eg_nid,
        aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        employerGroupStore.employerGroupResponseData.max_claim_date,
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });
  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  const [totalPages, setTotalPages] = useState(0);

  const [pageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [columnId, setColumnId] = useState<string>();
  const [memberListData, setMemberListData] = useState<any[]>([]);
  const [clickedMember, setClickedMember] = useState<string>('');
  const [selectedColumns, setSelectedColumns] = useState<string[]>(
    defaultOutNetworkMembersColumns,
  );
  const [tableColumns, setTableColumns] = useState<Columns[]>(
    getColumns(defaultOutNetworkMembersColumns),
  );
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [sortField, setSortField] = useState<string>('totalCost');
  const [sortOrder, setSortOrder] = useState<number>(-1);

  //Functions

  const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
    setPageNumber(page);
  };

  const handleMemberClick = (value: string) => {
    setClickedMember(value);
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };
  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  const handleChangeColumns = () => {
    setTableColumns(getColumns(selectedColumns));
    getNetworkMembersList();
  };

  const handleMembersTableSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    setSortField(sortColumnName);
    setSortOrder(sortOrder);
  };

  const handleExportCSV = () => {
    handleDownloadCSV(
      properties.aiqBaseUrl +
        properties.networkBaseUrl +
        properties.outNetworkMembersList +
        '/csv',
      membersListRequestBody,
      `OUT Network Members.csv`,
      handleOpenSnackBar,
    );
  };

  //API Calls
  const getNetworkData = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.networkBaseUrl +
      properties.amountRatio;
    const requestBody = {
      ...payload,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      network_indicator: [selectedNetworkIndicator],
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      claim_id_list: cohortDetailsStore.claimIdList,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res: any) => {
        if (res) {
          setTotalCost(res?.data.data[0]);
        }
      })
      .catch(() => {});
  };

  const getNetworkSummary = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.networkBaseUrl +
      properties.networkSummary;
    const body = {
      ...payload,
      network_indicator: selectedNetworkIndicator,
      sortField: 'totalCharge',
      pageNumber: 0,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      claim_id_list: cohortDetailsStore.claimIdList,
    };
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res) {
          setNetworkSummaryAPIRes(res.data.data);
        }
      })
      .catch(() => {});
  };

  const getNetworkUtilization = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.networkBaseUrl +
      properties.networkUtilization;
    const requestBody = {
      ...payload,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      claim_id_list: cohortDetailsStore.claimIdList,
      networkIndicator: selectedNetworkIndicator,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res: any) => {
        if (res) {
          setNetworkUtilization(res.data.data);
        }
      })
      .catch(() => {});
  };

  const getMemberClaims = async (memberId: string, claimIds: string[]) => {
    return await axios
      .post(
        properties.aiqBaseUrl +
          properties.membersBaseUrl +
          properties.memberDetails,
        {
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          paidStartDate,
          paidEndDate,
          incurredStartDate,
          incurredEndDate,
          aggregationParameter,
          member_unique_id: [memberId],
          claim_id_list: claimIds,
        },
        { signal: abortController.signal },
      )
      .then((response) => response.data);
  };

  const membersListRequestBody = {
    eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
    member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
    pageNumber: pageNumber - 1,
    pageSize: pageSize,
    sortField: sortField,
    sortOrder: sortOrder,
    startDate:
      aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
    endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
    max_claim_date: employerGroupStore.employerGroupResponseData.max_claim_date,
    columnList: selectedColumns,
    network_indicator: selectedNetworkIndicator,
    // showAll: previousYearCostSortFields?.includes(sortField),
  };

  const getNetworkMembersList = async () => {
    setTableLoading(true);

    const response = await axios.post(
      properties.aiqBaseUrl +
        properties.networkBaseUrl +
        properties.outNetworkMembersList,
      membersListRequestBody,
      { signal: abortController.signal },
    );

    if (response?.status === 200) {
      const updatedData = await Promise.all(
        response?.data?.data?.membersList?.map(async (item: any) => {
          const memberClaimsData = await getMemberClaims(
            item['Member ID'],
            item?.claims,
          );
          return {
            ...item,
            claimData: memberClaimsData?.data,
          };
        }),
      );

      setTotalPages(Math.ceil(response?.data?.data?.totalMembers / pageSize));
      setMemberListData(formatMembersListData(updatedData, selectedColumns));
      setTableLoading(false);
    }
  };

  const recommendedTabStore = useStores().recommendedTabStore;

  const apiCalls = async () => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([
        getNetworkData(),
        getNetworkSummary(),
        getNetworkUtilization(),
      ]).then(() => {
        setLoading(false);
      }));

    setLoading(false);
  };

  //Data Preparation
  const getDataForNetworkTable = () => {
    const InNetworkTableData: any[] = [];
    networkSummaryAPIRes?.forEach((item) => {
      const row = [];
      row.push(item.providerName);
      row.push(item.providerType);
      row.push(item.claims);
      row.push(addPrefix('$', item.totalCharge.toFixed(2)));
      row.push(addPrefix('$', item.memberPaid.toFixed(2)));
      row.push(addPrefix('$', item.planPaid.toFixed(2)));
      InNetworkTableData.push(row);
    });
    return InNetworkTableData;
  };

  const getDataForNetworkUtilizationChart = () => {
    const inMemberPaidData: any[] = [];
    const inPlanPaidData: any[] = [];
    const outMemberPaidData: any[] = [];
    const outPlanPaidData: any[] = [];

    networkUtilization?.in?.forEach((item) => {
      const memberPaidObj = { value: '' };
      const planPaidObj = { value: '' };
      memberPaidObj.value = String(item.totalmemberPaid);
      planPaidObj.value = String(item.totalPlanPaid);
      inMemberPaidData.push(memberPaidObj);
      inPlanPaidData.push(planPaidObj);
    });

    networkUtilization?.out?.forEach((item) => {
      const memberPaidObj = { value: '' };
      const planPaidObj = { value: '' };
      memberPaidObj.value = String(item.totalmemberPaid);
      planPaidObj.value = String(item.totalPlanPaid);
      outMemberPaidData.push(memberPaidObj);
      outPlanPaidData.push(planPaidObj);
    });

    return {
      inMemberPaidData: inMemberPaidData,
      inPlanPaidData: inPlanPaidData,
      outMemberPaidData: outMemberPaidData,
      outPlanPaidData: outPlanPaidData,
    };
  };

  const getDataForNetworkUtilizationTableData = () => {
    const formattedData = networkUtilization?.in?.map((inEntry) => {
      return [
        getMonth(inEntry.month, inEntry.year),
        numberToCurrencyFormatter(inEntry.totalmemberPaid, true, 2),
        numberToCurrencyFormatter(inEntry.totalPlanPaid, true, 2),
      ];
    });

    return formattedData;
  };

  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);
      const cleanData = {
        title_1: totalCost,
        title_2: networkSummaryAPIRes,
        title_3: networkUtilization,
        title_4: memberListData,
      };
      let resultArray = [];
      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.NETWORK_USAGE,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: cleanData,
          },
        );

        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
        console.error('AI Summary API failed:', apiError);
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error) {
      console.error('Unexpected Error:', error);
      handleOpenSnackBar(
        'Something went wrong. Please try again.',
        'error',
        6000,
      );
      setAiSummaryData([]);
    } finally {
      setAiLoading(false);
    }
  };

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    if (!selectedNetworkIndicator) {
      return;
    }
    getCategoryOfMonth();
    apiCalls();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
    selectedNetworkIndicator,
  ]);

  useEffect(() => {
    if (!selectedNetworkIndicator) {
      return;
    }
    getNetworkMembersList();
  }, [
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    pageNumber,
    sortField,
    sortOrder,
    selectedNetworkIndicator,
  ]);

  useEffect(() => {
    setSelectedNetworkIndicator(
      employerGroupStore.employerGroupResponseData.network_indicator_list[0],
    );
  }, [employerGroupStore.employerGroupResponseData.network_indicator_list]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  useEffect(() => {
    if (clickedMember) {
      memberSummaryStore.setPathDetails([
        [
          'text',
          'Network Usage',
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
        ],
      ]);
      navigate(PATIENT_DETAILS, { state: { memberId: clickedMember } });
    }
  }, [clickedMember]);

  const { classes } = useStyles();

  const EnrollmentAnalysis = () => {
    return (
      <Box className={classes.flexContainer}>
        <OverViewCard
          title={networkLeakage.cardText.totalCost}
          value={'$' + numFormatterWithSuffix(totalCost?.total_paid ?? 0, 2)}
          isMultiValued={true}
          rightLabelValues={[
            [
              networkLeakage.cardText.memberPaid,
              '$' + numFormatterWithSuffix(totalCost?.member_paid ?? 0, 2),
            ],
            [
              networkLeakage.cardText.planPaid,
              '$' + numFormatterWithSuffix(totalCost?.plan_paid ?? 0, 2),
            ],
          ]}
          rootStyles={{
            width: '350px',
          }}
          labelsMinWidth="100px"
        />
      </Box>
    );
  };

  const getCategoryOfMonth = () => {
    const sDate =
      aggregationParameter === 'paid' ? paidStartDate : incurredStartDate ?? '';
    const eDate =
      aggregationParameter === 'paid' ? paidEndDate : incurredEndDate ?? '';
    const startDateOfMoment = moment(sDate);
    const endDateOfMoment = moment(eDate);
    // const startDateOfMoment = moment('2021-01-01'); Test DATA
    // const endDateOfMoment = moment('2022-02-01');

    const category = [];

    while (startDateOfMoment.isSameOrBefore(endDateOfMoment)) {
      category.push({
        label:
          startDateOfMoment.format('MMM') +
          '<br><br>' +
          startDateOfMoment.format('YYYY'),
      });

      startDateOfMoment.add(1, 'month');
    }

    return category;
  };

  const NetworkUtilization = () => {
    return (
      <Box style={{ position: 'relative' }}>
        {/* <NetworkUtilizationChart
          category={getCategoryOfMonth()}
          inMemberPaidData={
            getDataForNetworkUtilizationChart().inMemberPaidData
          }
          inPlanPaidData={getDataForNetworkUtilizationChart().inPlanPaidData}
          outMemberPaidData={
            getDataForNetworkUtilizationChart().outMemberPaidData
          }
          outPlanPaidData={getDataForNetworkUtilizationChart().outPlanPaidData}
        /> */}
      </Box>
    );
  };

  const [loader] = useState<any>(<Loader />);
  const getPath = () => {
    if (pathStore.path.length !== 0) {
      return pathStore.path;
    } else {
      return [];
    }
  };

  const handleSort: any = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const sortColumnName = column.sortColumnName;
    if (!sortColumnName) {
      return;
    }

    const tableData = networkSummaryAPIRes;

    const newList = tableData
      ? [...tableData].sort((a: any, b: any) => {
          if (a[sortColumnName] < b[sortColumnName]) {
            return -1 * sortOrder;
          } else if (a[sortColumnName] > b[sortColumnName]) {
            return 1 * sortOrder;
          }
          return 0;
        })
      : [];

    setNetworkSummaryAPIRes(newList);
  };

  return isPlanDatesLoading || loading || isInitializing ? (
    loader
  ) : (
    <Box className={classes.mainDiv}>
      {getPath().length !== 0 && (
        <Box style={{ marginBottom: '20px' }}>
          <Breadcrumbs itemList={getPath()} />
        </Box>
      )}
      <>
        <Box style={{ width: '1182px', position: 'relative' }}>
          <PageTitleAndSubTitle
            title={
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                  maxWidth: '100%',
                }}
              >
                {' '}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography
                    fontSize="18px"
                    lineHeight="22px"
                    fontType="semiBold"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                    margin="0px 8px 0px 0px"
                  >
                    {networkLeakage.titleAndSubtitle.title + ' by '}
                  </Typography>
                  <DashedStandardDropdown
                    options={
                      employerGroupStore.employerGroupResponseData
                        .network_indicator_list
                    }
                    displayValue={
                      employerGroupStore.employerGroupResponseData
                        .network_indicator_list
                    }
                    value={selectedNetworkIndicator}
                    handleChange={(e: any) => {
                      setSelectedNetworkIndicator(e.target.value as string);
                    }}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    fontSize="17px"
                    lineHeight="21px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                    fontType="semiBold"
                    margin="0px 8px"
                  >
                    {COMMON_TEXTS.FOR}
                  </Typography>
                  <DateFilter />
                </div>
              </div>
            }
            subTitle={''}
            showDownloadButton={true}
            subTitleStyles={{
              width: '100%',
            }}
            showQueryDataButton={checkUserAccess(
              UserAccessConstants.COHORT_DETAILS,
              loginPageStore.userResponse.role.name,
              loginPageStore.userFeatures,
            )}
            queryButtonText={
              cohortDetailsStore.cohortDetailsList?.length > 0 &&
              cohortDetailsStore.cohortDetailsList[0].category !== ''
                ? 'Edit Cohort'
                : 'Add Cohort'
            }
            queryDataAction={() => {
              if (
                checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )
              ) {
                openModal();
              }
            }}
            downloadButtonAction={() => {
              downloadPdf(
                'networkLeakageReport',
                {
                  employer:
                    employerGroupStore?.employerGroupResponseData
                      ?.employer_group_name,
                  member_unique_id_list: [],
                  claim_id_list: [],
                  maxClaimDate:
                    employerGroupStore?.employerGroupResponseData
                      ?.max_claim_date,
                  networkIndicator: selectedNetworkIndicator,
                  ...payload,
                },
                handleOpenSnackBar,
                'open',
              );
              handleOpenSnackBar(
                snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                'info',
                6000,
              );
            }}
            showAskAi={true}
            askAiAction={handleAskAi}
          />

          <TabSelection
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={handleSelectedIndex}
            recommendationFetched={recommendationFetched}
          />
        </Box>
      </>

      {selectedTabIndex === 0 && (
        <>
          {/* {cohortDetailsStore.conditionsDetails &&
            cohortDetailsStore.conditionsDetails?.length > 0 && (
              <Grid
                container
                direction="row"
                className={classes.queryDataOverallGrid}
              >
                <Grid item className={classes.queryIconGrid}>
                  <QueryIcon />
                </Grid>
                {cohortDetailsStore.conditionsDetails?.map(
                  (detail, index: number) => {
                    return (
                      <Tooltip
                        key={index}
                        arrow={true}
                        placement="bottom-end"
                        classes={{
                          tooltip: classes.tooltip,
                          arrow: classes.arrow,
                        }}
                        title={
                          <Grid container direction="column">
                            {cohortDetailsStore.conditionsDetails?.map(
                              (detail, index: number) => {
                                return (
                                  <Grid key={index} item>
                                    {detail}
                                  </Grid>
                                );
                              },
                            )}
                          </Grid>
                        }
                      >
                        <Grid item className={classes.queryDataGrid}>
                          <Typography
                            className={classes.queryDataTypography}
                            lineHeight="25px"
                            fontSize="14px"
                            fontType="regular"
                          >
                            {detail}
                          </Typography>
                        </Grid>
                      </Tooltip>
                    );
                  },
                )}
              </Grid>
            )} */}
          <CohortFilterBar />
          <EnrollmentAnalysis />
          <Grid style={{ marginTop: '28px' }}>
            <CustomColumnsTable
              title={`${selectedNetworkIndicator} Network Member Details`}
              subTitle={`View the members with ${selectedNetworkIndicator} network indicator`}
              options={outNetworkColumns}
              mandateOptions={['Member ID']}
              selectedItems={selectedColumns}
              setSelectedItems={setSelectedColumns}
              handleChangeColumns={handleChangeColumns}
              handleExport={handleExportCSV}
              columns={tableColumns}
              rowsData={memberListData}
              tableLoading={tableLoading}
              handleMemberClick={handleMemberClick}
              handleSort={handleMembersTableSort}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
              pageNumber={pageNumber}
            />
          </Grid>
          {/* Hide network utilization trend chart */}
          {false && <NetworkUtilization />}
          {/* In network and out network data */}
          <CardComponent
            title={'Network Utilization'}
            subTitle={'This table shows the distribution of paid amounts'}
            width="1176px"
            mainGridStyles={{
              marginTop: '28px',
            }}
            body={
              <BasicTable
                displayType="row"
                rowsData={getDataForNetworkUtilizationTableData()}
                columns={networkUtilizationColumns}
                isFullTable
              />
            }
          />
          <Box>
            <CardTable
              title={networkLeakage.TableText.title(selectedNetworkIndicator)}
              subtitle={networkLeakage.TableText.subtitle}
              showToggle={false}
              rowData={getDataForNetworkTable()}
              columnsData={memberTableColumns}
              columnId={columnId}
              handleHeaderMouseEnter={(column: any) =>
                handleHeaderMouseEnter(column, setColumnId)
              }
              handleHeaderMouseLeave={() => handleHeaderMouseLeave(setColumnId)}
              showOnHoverHeader={true}
              handleMenuItem={handleSort}
              cardHeight="auto"
            />
          </Box>
        </>
      )}
      {selectedTabIndex === 1 && (
        <div style={{ height: '493px', padding: '20px' }}>
          <RecommendationsTab
            recommendationLoading={recommendationLoading}
            isInternalPage={true}
          />
        </div>
      )}
      <FeatureAccessModal
        open={openFeatureAccessModal}
        handleClose={() => {
          setOpenFeatureAccessModal(false);
        }}
        access={checkUserAccess(
          UserAccessConstants.COHORT_DETAILS,
          loginPageStore.userResponse.role.name,
          loginPageStore.userFeatures,
        )}
      ></FeatureAccessModal>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData || []}
        loading={aiLoading}
      />
    </Box>
  );
});

export default NetworkLeakagePage;
